import React from 'react';
import dayjs from 'dayjs';
import SignatureImage from '../../components/Agreement/SignatureImage';

const Signature = props => {
  const { signature } = props;
  const { Signature: SignatureData, SignatureTime } = signature;

  return (
    <div className={'signature'}>
      {/* <div className="bold">
        <span className={'red'}>*</span>
        <span className={'label'}>客人签署</span>
      </div> */}
      <div className={'signature-canvas'}>
        {SignatureData && <SignatureImage SignatureData={SignatureData} />}
      </div>
      <div className={'signature-date-container row'}>
        {/* <div className={'checkbox'}>
          <div className={'check-mark'}></div>
        </div> */}
        <div className={'signature-date'}>
          {/* <span>本人清楚明白本合约内容并同意遵守服务条款之守则及规例。</span> */}
          <span>签署日期：{SignatureTime && dayjs(SignatureTime).format('DD/MM/YYYY HH:mm:ss')}</span>
        </div>
      </div>
    </div>
  );
};

export default Signature;